require(['app/config.js', 'app/translations.js', 'app/services.js', 'app/directives.js', 'app/controllers.js', 'https://cdnjs.cloudflare.com/ajax/libs/angular-ui-bootstrap/1.3.3/ui-bootstrap-tpls.min.js', 'https://cdnjs.cloudflare.com/ajax/libs/angular-translate/2.12.1/angular-translate.min.js'], function(config, translations, services, directives, controllers) { 
    var app = angular.module('app', ['ngRoute', 'ui.bootstrap', 'pascalprecht.translate']);
    app.config(config);
    app.config(translations);
    
    app.service('dataService', services.dataService);
    app.controller('AppCtrl', controllers.appCtrl);
    app.controller('ResultCtrl', controllers.resultCtrl);
});
define("app/app.js", function(){});

